export { Sender } from "./Sender";
//# sourceMappingURL=applicationinsights-channel-js.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@microsoft/applicationinsights-channel-js/dist-esm/applicationinsights-channel-js.js
// module id = 221
// module chunks = 42